import React from "react";
import {HashRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import {Auth} from "sbx-react-auth-hoc";
import "./App.scss";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "./Store/Reducers";
import {AuthActions} from "./Store/Auth/Slice";
import ModalWrapperComponent from "./Components/ModalWrapper/ModalWrapperComponent";
import SlideMenuComponent from "./Components/SlideMenu/SlideMenuComponent";
import NavBarComponent from "./Components/NavBar/NavBarComponent";
import {CompanyActions} from "./Store/Company/Slice";
import DashboardComponent from "./Components/Dashboard/DashboardComponent";
import SignInComponent from "./Components/Login/SignInComponent";
import BillingComponent from "./Components/Billing/BillingComponent";
import HistoryComponent from "./Components/History/HistoryComponent";
import ShipmentDetailComponent from "./Components/Shipment/ShipmentDetailComponent/ShipmentDetailComponent";
import ReportsComponent from './Components/Dashboard/ManagementReport/ReportsComponent';

const App = () => {

  const {authReducer: {logged}} = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const authSuccess = (res: any) => {
    dispatch(AuthActions.setLogin(res));
    dispatch(CompanyActions.clearState());
    dispatch(CompanyActions.setCompany(res));
  };

  const authError = () => {
    console.log('error');
  };

  return (
    <Router>
      <Auth
        onError={authError}
        onSuccess={authSuccess}
        logged={logged}
        onErrorComponent= {
          <Switch>
            <Route exact path="/login">
              <SignInComponent/>
            </Route>
            <Route exact path="/shipment">
              <NavBarComponent/>
              <SlideMenuComponent/>
              <ShipmentDetailComponent/>
            </Route>
            <Redirect from="*" to="/login"/>
          </Switch>
        }
      >

        <NavBarComponent/>
        <SlideMenuComponent/>

        <Switch>
          <Route exact path="/dashboard">
            <DashboardComponent/>
          </Route>
          <Route exact path="/reports">
            <ReportsComponent/>
          </Route>
          <Route exact path="/billing">
            <BillingComponent/>
          </Route>

          <Route exact path="/history">
            <HistoryComponent/>
          </Route>

          <Route exact path="/shipment">
            <ShipmentDetailComponent/>
          </Route>

          <Redirect from="*" to="/dashboard"/>
        </Switch>
      </Auth>
      <ModalWrapperComponent/>
    </Router>
  );
}

export default App;
